import { ElLoading } from "element-plus";

/**
 * Receives an object containing title, message, and type for the message and shows the message
 */

let loader: any = null;
export const loaderStart = () => {
  loader = ElLoading.service({ fullscreen: true });
};

/**
 * Receives an object containing just title and message for the message and shows the notification
 */
export const loaderDone = () => {
  if (loader) loader.close();
};
